import React from "react";
import withStyles from "react-jss";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";

const styles = (theme) => {
	return {
		CardLink: {
			display: "flex",
			flexDirection: "column",
			boxSizing: "border-box",
			fontFamily: theme.fonts.medium,
			backgroundColor: theme.palette.colors.white,
			border: `1px solid ${theme.palette.colors.disabled}`,
			borderRadius: "10px",
			padding: "15px",
			height: "100%",
		},
		CardLinkTopBlock: {
			display: "flex",
			flexDirection: "column",
			height: "55%",
		},
		CardLinkAdress: {
			fontFamily: theme.fonts.bold,
			color: theme.palette.colors.darkSlateBlue2,
			fontSize: "18px",
			lineHeight: "22px",
			marginTop: "auto",
			marginBottom: "auto",
			cursor: "pointer",
		},
		CardLinkLogoRow: {
			display: "flex",
			justifyContent: "space-around",
			gap: "10px",
			height: "30px",
			marginTop: "auto",
			marginBottom: 0,
			"& img": {
				height: "auto",
				width: "calc(20% - 10px)",
				objectFit: "contain",
			},
		},
		CardLinkFeatures: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			marginTop: "20px",
		},
		CardLinkFeaturesText: {
			color: theme.palette.colors.darkSlateBlue2,
			fontSize: "14px",
			lineHeight: "14px",
			width: "55%",
		},
		CardLinkFeaturesNum: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			color: theme.palette.colors.darkSlateBlue2,
			fontSize: "18px",
			lineHeight: "14px",
			width: "45%",
		},
		CardLinkFeaturesUnit: {
			fontFamily: theme.fonts.light,
			color: theme.palette.colors.oneMoreGrey,
			fontSize: "12px",
			lineHeight: "10px",
			marginLeft: "3px",
		},
		CardLinkBadge: {
			display: "flex",
			justifyContent: "center",
			alignItems: "baseline",
			width: "fit-content",
			backgroundColor: theme.palette.colors.giftPink,
			color: theme.palette.colors.white,
			fontSize: "12px",
			lineHeight: "12px",
			border: `1px solid ${theme.palette.colors.giftPink}`,
			borderRadius: "30px",
			padding: "3px 10px",
		},
		CardLinkBadgeText: {
			fontFamily: theme.fonts.light,
			color: theme.palette.colors.oneMoreGrey,
			fontSize: "12px",
			lineHeight: "12px",
		},
		CardLinkBottomBlock: {
			display: "flex",
			flexDirection: "column",
			height: "45%",
		},
		CardLinkReview: {},
		CardLinkReviewName: {
			color: theme.palette.colors.darkSlateBlue2,
			fontSize: "14px",
			lineHeight: "16px",
			marginBottom: "4px",
		},
		CardLinkReviewDate: {
			color: theme.palette.colors.cloudyBlue,
			fontSize: "12px",
			lineHeight: "14px",
		},
		CardLinkReviewProvider: {
			color: theme.palette.colors.darkSlateBlue2,
			fontSize: "12px",
			lineHeight: "14px",
			marginBottom: "8px",
		},
		CardLinkReviewText: {
			fontFamily: theme.fonts.light,
			color: theme.palette.colors.oneMoreGrey,
			fontSize: "14px",
			lineHeight: "16px",
		},
		CardLinkFixBlock: {
			height: "32px",
		},
		CardLinkRightBlock: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-end",
			marginTop: "10px",
		},
		dislike: {
			marginBottom: "5px",
		},
		Unit: {
			fontFamily: "sans-serif",
		},
		UnitMargin: {
			marginRight: "3px",
		},
		[`@media (max-width: ${theme.media.md})`]: {
			// CardLink:{
			//     boxSizing: "inherit",
			// },
			CardLinkFeaturesText: {
				fontSize: "12px",
				whiteSpace: "nowrap",
			},
			CardLinkFeaturesNum: {
				fontSize: "16px",
			},
			CardLinkReviewName: {
				fontSize: "12px",
				lineHeight: "14px",
			},
			CardLinkReviewDate: {
				fontSize: "10px",
				lineHeight: "14px",
			},
			CardLinkReviewProvider: {
				fontSize: "10px",
				lineHeight: "14px",
			},
			CardLinkReviewText: {
				fontSize: "12px",
				lineHeight: "14px",
			},
		},
		[`@media (max-width: ${theme.media.xs})`]: {
			CardLinkReviewProvider: {
				marginBottom: "5px",
			},
		},
	};
};

const CardLink = (props) => {
	const history = useHistory();

	let {
		classes,
		place,
		adress,
		url,
		avg_speed,
		avg_price,
		price_diff,
		review,
		providers,
		commonViewModel,
		// onClickHandler,
	} = props;

	const handleClickLink = (e) => {
		//Здесь костыль из-за того, что OnClick в компоненте Link не всегда вызывается
		if (!!e) {
			e.preventDefault();
			e.stopPropagation();
		}

		commonViewModel.changeShowModalOnRates(true);

		history.push({
			pathname: url,
		});
	};

	const reviewText =
		review?.review.length > 150 ? review?.review.slice(0, 150).trim() + "..." : review?.review;
	let logoList = providers.map((elem) => {
		return <img key={elem.id} src={elem.logo} alt={elem.name}></img>;
	});

	let reviewDate;

	if (review?.date) {
		let reviewDateStamp = new Date(review?.date);
		reviewDate = reviewDateStamp.toLocaleString("default", {
			day: "numeric",
			month: "long",
			year: "numeric",
		});
	}

	const autorName = isNaN(+review?.author.name) ? review?.author.name : `Житель ${place}`;
	return (
		<div className={classes.CardLink}>
			<div className={classes.CardLinkTopBlock}>
				<Link className={classes.CardLinkAdress} onClick={handleClickLink} to={url}>
					{adress}
				</Link>
				<div className={classes.CardLinkLogoRow}>{logoList}</div>
				<div className={classes.CardLinkFeatures}>
					<div className={classes.CardLinkFeaturesText}>Средняя скорость</div>
					<div className={classes.CardLinkFeaturesNum}>
						{avg_speed}
						<div className={classes.CardLinkFeaturesUnit}>Мбит/с</div>
					</div>
				</div>
				<div className={classes.CardLinkFeatures}>
					<div className={classes.CardLinkFeaturesText}>Средняя цена</div>
					<div className={classes.CardLinkFeaturesNum}>
						{avg_price}
						<div className={classes.CardLinkFeaturesUnit}>
							<span className={classes.Unit}>₽</span>/мес
						</div>
					</div>
				</div>
				<div className={classes.CardLinkFixBlock}>
					{price_diff && (
						<div className={classes.CardLinkRightBlock}>
							<div className={classes.CardLinkBadge}>
								на {price_diff}
								<span className={`${classes.Unit} ${classes.UnitMargin}`}>₽</span> дороже
							</div>
							<div className={classes.CardLinkBadgeText}>чем в вашем доме</div>
						</div>
					)}
				</div>
			</div>

			<div className={classes.CardLinkBottomBlock}>
				{review && (
					<div className={classes.CardLinkReview}>
						<div className={classes.CardLinkReviewName}>{autorName}</div>
						<div className={classes.CardLinkReviewDate}>{reviewDate && reviewDate}</div>
						<div className={classes.CardLinkReviewProvider}>{review.provider.name}</div>
						<div className={classes.CardLinkReviewText}>{reviewText}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default withStyles(styles)(CardLink);
